import { render, staticRenderFns } from "./OwersBooks.vue?vue&type=template&id=6b5869f3&scoped=true&"
import script from "./OwersBooks.vue?vue&type=script&lang=js&"
export * from "./OwersBooks.vue?vue&type=script&lang=js&"
import style0 from "./OwersBooks.vue?vue&type=style&index=0&id=6b5869f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5869f3",
  null
  
)

export default component.exports